export default [
    6,
    7,
    8,
    98,
    99,
    100,
    190,
    280,
    281,
    371,
    461,
    641,
    731,
    911,
    910,
    1000,
    999,
    1088,
    1178,
    1177,
    1176,
    1171,
    1081,
    1262,
    1261,
    1351,
    1350,
    1440,
    1710,
    1800,
    1890,
    1980,
    2070,
    2071,
    2161,
    2251,
    2252,
    2253,
    2344,
    2346,
    2347,
    2348,
    2349,
    2261,
    2171,
    2082,
    1992,
    1813,
    1723,
    1543,
    1363,
    1273,
    1272,
    1182,
    1181,
    1091,
    1090,
    1633,
    1080,
    2350,
    282,
    192,
    193,
    194,
    105,
    107,
    108,
    199,
    200,
    292,
    473,
    564,
    654,
    655,
    745,
    835,
    925,
    1015,
    1105,
    1195,
    1194,
    1284,
    1374,
    1373,
    1372,
    1462,
    1461,
    1460,
    1459,
    1548,
    1547,
    1454,
    201,
    383,
    106,
    2439,
    2529,
    2619,
    2709,
    2799,
    2889,
    2980,
    3071,
    3072,
    3162,
    3164,
    3166,
    3167,
    3168,
    3079,
    3080,
    2902,
    2813,
    2723,
    2633,
    2543,
    2453,
    2363,
    2273,
    2183,
    2093,
    2003,
    1913,
    1823,
    1822,
    1732,
    1731,
    1641,
    1551,
    1550,
    3163,
    2991,
    3161,
    3251,
    3341,
    3431,
    3430,
    3520,
    3519,
    2634,
    2544,
    2545,
    2546,
    2636,
    2638,
    2639,
    2730,
    2731,
    2821,
    2913,
    3095,
    3185,
    3186,
    3276,
    3366,
    3456,
    3546,
    926,
    927,
    1019,
    1020,
    1112,
    1203,
    1294,
    1656,
    1837,
    2017,
    2107,
    2197,
    2287,
    2377,
    2555,
    2644,
    2734,
    2733,
    2823,
    2822,
    1927,
    1746,
    1385,
    1475,
    1565,
    1021,
    1018,
    384,
    385,
    386,
    387,
    388,
    389,
    390,
    391,
    302,
    303,
    304,
    305,
    215,
    216,
    126,
    127,
    37,
    398,
    397,
    307,
    489,
    490,
    581,
    671,
    762,
    852,
    943,
    1033,
    1123,
    1213,
    1303,
    1393,
    1483,
    1482,
    1572,
    1662,
    1661,
    1750,
    1749,
    1748,
    1747,
    1663,
    1847,
    1757,
    1756,
    1666,
    1665,
    2027,
    2028,
    2118,
    2208,
    2298,
    2388,
    2477,
    2567,
    2656,
    2746,
    2835,
    2923,
    3013,
    3012,
    3102,
    3101,
    3100,
    3099,
    3098,
    3097,
    1937,
    2664,
    2665,
    2755,
    2845,
    2846,
    2936,
    2937,
    3117,
    3207,
    3208,
    3298,
    3566,
    2483,
    2482,
    2392,
    2391,
    2390,
    2389,
    3388,
    3478,
    3567,
    46,
    47,
    138,
    139,
    229,
    230,
    320,
    410,
    500,
    590,
    680,
    770,
    860,
    950,
    1040,
    1130,
    1219,
    1309,
    1398,
    1488,
    1487,
    1577,
    1576,
    861,
    1325,
    1324,
    1233,
    1142,
    1141,
    1050,
    1049,
    958,
    957,
    956,
    864,
    863,
    1415,
    1505,
    1595,
    1775,
    1865,
    1955,
    2044,
    2134,
    2224,
    2223,
    2312,
    2402,
    2401,
    2400,
    2490,
    2489,
    2488,
    2487,
    2486,
    2485,
    2575,
    1685,
    862,
    961,
    962,
    963,
    964,
    965,
    966,
    968,
    880,
    791,
    792,
    614,
    524,
    434,
    344,
    254,
    255,
    75,
    967,
    879,
    794,
    884,
    885,
    975,
    1065,
    1066,
    1157,
    1247,
    1338,
    1339,
    1340,
    1431,
    1432,
    1433,
    1435,
    1346,
    1347,
    1348,
    1349,
    1345,
    2225,
    2315,
    2316,
    2406,
    2407,
    2497,
    2498,
    2500,
    2502,
    2503,
    2415,
    2326,
    1970,
    1791,
    1701,
    1611,
    1521,
    1881,
    2504,
    2501,
    2595,
    2594,
    2684,
    2774,
    2864,
    3134,
    3225,
    3315,
    3405,
    3406,
    3407,
    3499,
    3500,
    3501,
    3591,
    3592,
    3593,
    3044,
    3224,
    3314,
    3313,
    3403,
    3493,
    3492,
    3582,
    876,
    153,
    243,
    244,
    334,
    335,
    425,
    426,
    427,
    428,
    431,
    521,
    522,
    523,
    433,
    430,
    429,
    63,
    1972,
    1974,
    2065,
    2067,
    2157,
    2158,
    2248,
    2249,
    2339,
    1883,
    2554,
    1086,
    1455,
    1546,
    1175,
    1263,
    821,
    2556,
    2467,
    2484,
    1316,
    1315,
    1314,
    1403,
    1493,
    1492,
    1582,
    1672,
    1761,
    1851,
    1852,
    1942,
    1943,
    2033,
    2034,
    2035,
    2036,
    2038,
    2039,
    1949,
    1950,
    1951,
    1317,
    1318,
    1319,
    1320,
    1321,
    1412,
    1502,
    1592,
    1682,
    1772,
    1862,
    1861,
    4,
    94,
    184,
    275,
    365,
    455,
    545,
    633,
    632,
    540,
    793,
    1150,
    1240,
    1239,
    1329,
    1419,
    1509,
    1599,
    1689,
    1779,
    1869,
    1960,
    1961,
    1962,
    1963,
    1873,
    1874,
    1784,
    1695,
    1605,
    1515,
    1425,
    1424,
    1423,
    1512,
    1602,
    2673,
    2763,
    2764,
    2765,
    2855,
    2856,
    2946,
    3036,
    3126,
    3216,
    3306,
    3396,
    3395,
    3394,
    3304,
    3303,
    3213,
    3212,
    3122,
    3121,
    2929,
    3467,
    3377,
    3378,
    3379,
    3289,
    3290,
    3291,
    3201,
    3202,
    3112,
    3111,
    3021,
    3020,
    2930,
    3282,
    3372,
    3461,
    3551,
    3552,
    3553,
    3087,
    3177,
    3268,
    3448,
    3538,
    3537,
    3534,
    3533,
    3532,
    3442,
    3262,
    3263,
    3173,
    3174,
    3084,
    3085,
    3086,
    3536,
    3535,
    2512,
    2602,
    2601,
    2691,
    2781,
    2871,
    2961,
    3051,
    3141,
    3142,
    3232,
    3233,
    3234,
    3235,
    3236,
    3237,
    3147,
    3058,
    2968,
    2878,
    2788,
    2698,
    2697,
    2607,
    2517,
    2516,
    2515,
    2514,
    2513,
    261,
    351,
    441,
    440,
    530,
    620,
    710,
    800,
    801,
    891,
    892,
    894,
    895,
    896,
    897,
    898,
    899,
    539,
    355,
    354,
    264,
    263,
    262,
    266,
    176,
    86,
    1559,
    1649,
    1650,
    1740,
    1741,
    1831,
    1921,
    2011,
    2101,
    2100,
    2099,
    2098,
    2008,
    2007,
    1917,
    1827,
    1737,
    2175,
    2265,
    2354,
    2444,
    2443,
    2533,
    2623,
    2714,
    2715,
    2716,
    2627,
    2537,
    2538,
    2359,
    2269,
    2179,
    2358,
    2113,
    2203,
    2202,
    2292,
    2382,
    2381,
    2380,
    2470,
    2560,
    2559,
    2649,
    2650,
    2651,
    313,
    314,
    404,
    405,
    495,
    496,
    586,
    676,
    677,
    767,
    145,
    144,
    324,
    414,
    504,
    505,
    595,
    596,
    597,
    598,
    508,
    509,
    419,
    420,
    330,
    329,
    239,
    466,
    556,
    646,
    736,
    826,
    916,
    1006,
    1007,
    1008,
    1009,
    1010,
    920,
    830,
    740,
    650,
    560,
    559,
    558,
    2703,
    2704,
    2794,
    2795,
    2885,
    2975,
    3065,
    3066,
    3156,
    3246,
    3245,
    3335,
    3334,
    3333,
    3332,
    3331,
    3241,
    3150,
    3060,
    2970,
    2971,
    2881,
    1537,
    1536,
    1626,
    1625,
    1715,
    1805,
    1806,
    1807,
    1808,
    1718,
    1719,
    1809,
    1810,
    1900,
    1899,
    1989,
    1988,
    2078,
    2077,
    2076,
    2075,
    1985,
    1984,
    755,
    845,
    846,
    847,
    848,
    938,
    1028,
    1029,
    1119,
    1209,
    1299,
    660,
    661,
    662,
    663,
    573,
    574,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    31,
    32,
    1708,
    1798,
    1799,
    1709,
    1885,
    2062,
    2061,
    2236,
    2237,
    2238,
    2148,
    2149,
    2059,
    786,
    696,
    606,
    605,
    604,
    513,
    512,
    511,
    421,
    147,
    237,
    327,
    326,
    146,
    55,
    1289,
    1290,
    1380,
    1381,
    1471,
    1472,
    1562,
    1563,
    1653,
    1744,
    1834,
    1924,
    2014,
    2104,
    2194,
    2193,
    2283,
    2282,
    2281,
    2371,
    2370,
    2369,
    1735,
    2005,
    2095,
    2185,
    2275,
    1376,
    1377,
    1287,
    644,
    734,
    824,
    914,
    1004,
    1185,
    1186,
    1276,
    1277,
    1187,
    1188,
    1189,
    1190,
    1191,
    1101,
    1102,
    1012,
    922,
    832,
    742,
    652,
    2211,
    2212,
    2213,
    2214,
    2215,
    2216,
    2306,
    2307,
    2308,
    2218,
    2219,
    2769,
    2859,
    2949,
    3039,
    3129,
    3219,
    3220,
    3130,
    3041,
    2951,
    2952,
    3488,
    3577,
    3576,
    3106,
    3016,
    3017,
    3560,
    3561,
    3562,
    3563,
    3473,
    3474,
    3384,
    3294,
    257,
    347,
    437,
    527,
    617,
    707,
    797,
    887,
    888,
    978,
    979,
    1069,
    1070,
    1071,
    1161,
    1162,
    1163,
    1164,
    1165,
    1166,
    1167,
    1168,
    716,
    626,
    625,
    534,
    533,
    622,
    178,
    268,
    269,
    131,
    220,
    310,
    311,
    946,
    1036,
    1126,
    1216,
    1306,
    1305,
    1842,
    1933,
    2020,
    2110,
    2109,
    2199,
    2999,
    3089,
    3090,
    3181,
    3182,
    3272,
    3273,
    3363,
    3453,
    3543,
    3524,
    3348,
    3347,
    3345,
    3346,
    3435,
    904,
    905,
    906,
    816,
    817,
    727,
    637,
    547,
    548,
    182,
    2,
    180,
    272,
    271,
    453,
    454,
    452,
    631,
    1042,
    1132,
    1134,
    1133
  ]